module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-28.5eebbf63.png";